import $ from 'jquery';
import { detectBrowser } from '~src/utils';

export const initBrowsersManagement = () => {
  const browser = detectBrowser();
  if (browser.isFirefox) {
    $('#editor-menu-print').hide();
  }
};
